import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom';
import TextInput from '../components/TextInput';
import FormActionButton from '../components/FormActionButton';
import Container from '../components/Container';
import Heading2 from '../components/Heading2';

const BillingAddressScreen: React.FC = () => {
  const userContext = useContext(UserContext);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const [billingAddress1, setBillingAddress1] = useState('');
  const [billingAddress2, setBillingAddress2] = useState('');
  const [houseNumber, setHouseNumber] = useState('');
  const [billingCity, setBillingCity] = useState('');
  const [billingState, setBillingState] = useState('');
  const [billingZipcode, setBillingZipcode] = useState('');
  const [billingCountry, setBillingCountry] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (userContext) {
      const { country, address, address2, house_number, city, state, zipcode } = userContext.userData.billingInfo || {};
      setBillingCountry(country || 'USA');
      setBillingAddress1(address || '');
      setBillingAddress2(address2 || '');
      setHouseNumber(house_number || '');
      setBillingCity(city || '');
      setBillingState(state || '');
      setBillingZipcode(zipcode || '');

      const { firstName, lastName, email, phoneNumber } = userContext.userData || {};
      setFirstName(firstName || '');
      setLastName(lastName || '');
      setEmail(email || '');
      setPhoneNumber(phoneNumber || '');

      console.log('BillingAddressScreen email', email);
    }
  }, [userContext]);

  if (!userContext) return null;

  const { userData, setUserData } = userContext;

  const handleNext = () => {
    setUserData({
      ...userData,
      billingInfo: {
        first_name: firstName,
        last_name: lastName,
        name: `${firstName} ${lastName}`,
        email,
        phone: phoneNumber,
        country: billingCountry,
        address: billingAddress1,
        address2: billingAddress2,
        house_number: houseNumber,
        city: billingCity,
        state: billingState,
        zipcode: billingZipcode,
      },
    });
    // We have saved the data into the local context.
    // The next screen will uses it when adding payment data.
    navigate('/add-payment-card');
  };

  return (
    <Container>
      <Heading2>What's Your Billing Information?</Heading2>
      <p className="text-gray-700 mb-6">
        Even if your billing information is the same as your treatment location, please enter it below. We'll collect
        your payment information in the next step to make things easier on the day of your appointment.{' '}
        <span className="font-bold">We won't charge anything today!</span>
      </p>
      <div className="space-y-6">
        <TextInput
          label="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder="Jane"
        />
        <TextInput label="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Doe" />
        <TextInput
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="jane.doe@example.com"
        />
        <TextInput
          label="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="###-###-####"
        />

        <TextInput
          label="Address Line 1"
          value={billingAddress1}
          onChange={(e) => setBillingAddress1(e.target.value)}
          placeholder="123 Main St"
        />
        <TextInput
          label="Address Line 2"
          value={billingAddress2}
          onChange={(e) => setBillingAddress2(e.target.value)}
          placeholder="Apt, Suite, etc."
        />
        <TextInput
          label="City"
          value={billingCity}
          onChange={(e) => setBillingCity(e.target.value)}
          placeholder="City"
        />
        <TextInput
          label="State"
          value={billingState}
          onChange={(e) => setBillingState(e.target.value)}
          placeholder="State"
        />
        <TextInput
          label="Zip Code"
          value={billingZipcode}
          onChange={(e) => setBillingZipcode(e.target.value)}
          placeholder="12345"
        />
        <TextInput
          label="Country"
          value={billingCountry}
          onChange={(e) => setBillingCountry(e.target.value)}
          placeholder="USA"
        />
      </div>
      <div className="flex justify-center mt-8">
        <FormActionButton onClick={handleNext} isLoading={isLoading}>
          Continue to Payment Information
        </FormActionButton>
      </div>
      <div className="flex justify-center mt-8">
        <p className="text-gray-700 mb-6 font-bold text-center">
          Once you click continue, you'll be redirected to our secure payment form where you can enter your card
          details.
        </p>
      </div>
    </Container>
  );
};

export default BillingAddressScreen;
